"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _apiPaths = _interopRequireDefault(require("../constants/apiPaths"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useWorkflow = _ref => {
  let {
    workflowId,
    token,
    env = 'production',
    region = 'eu'
  } = _ref;
  const frameEl = /*#__PURE__*/(0, _react.createRef)();
  const apiPath = (0, _react.useMemo)(() => {
    return _apiPaths.default.find(path => {
      return path.env === env && path.region === region;
    });
  }, [env, region]);
  const targetOrigin = (0, _react.useMemo)(() => {
    if (window.location.hostname === 'localhost') return '*';
    return env === 'local' ? window.location.origin : "https://".concat(apiPath.origin);
  }, [env, apiPath]);
  const save = (0, _react.useCallback)(() => {
    frameEl.current.contentWindow.postMessage({
      action: 'save'
    }, targetOrigin);
  }, [frameEl, targetOrigin]);
  const deploy = (0, _react.useCallback)(() => {
    frameEl.current.contentWindow.postMessage({
      action: 'deploy'
    }, targetOrigin);
  }, [frameEl, targetOrigin]);
  const sendAccessToken = (0, _react.useCallback)(accessToken => {
    frameEl.current.contentWindow.postMessage({
      action: 'sendAccessToken',
      accessToken
    }, targetOrigin);
  }, [frameEl, targetOrigin]);
  return {
    workflowId,
    frameEl,
    save,
    deploy,
    sendAccessToken,
    apiPath,
    token,
    targetOrigin
  };
};
var _default = useWorkflow;
exports.default = _default;